<template>
  <div>
    <v-layout column v-if="shopLoad" align-center>
      <!--
        <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular>
      -->
      <progress-q></progress-q>
    </v-layout>
    <modal-q v-if="isLoading"></modal-q>
    <dialog-images
      v-if="dialogChangeIcon"
      :images="priceImages"
      :shop-id="shopID"
      :token="$store.getters.token"
      @close-dialog="() => (this.dialogChangeIcon = false)"
      @click-image="(item) => loadImage(item)"
      @image-uploaded="onImageUploaded"
    />
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12>
        <v-card v-if="!shopLoad" class="dash-card">
          <v-layout
            column
            align-center
            style="position: relative; padding-bottom: 50px"
          >
            <img
              height="400"
              @click="show = !show"
              :src="defaultAvatar"
              ref="avatar"
              class="avatar-img elevation-3"
              style="cursor: pointer"
              hover 
            />
            <img
              :src="
                shop.dlc === 'V10'
                  ? '../../../static/img/ICON-free.png'
                  : shop.dlc === 'V14'
                  ? '../../../static/img/ICON-platinum.png'
                  : '../../../static/img/ICON-silver.png'
              "
              class="img-badge"
            />
            <div class="wrapper-logo" @click="showLogoUpload = !showLogoUpload">
              <img ref="logo" :src="shop.logoLink" class="img-logo" />
            </div>
            <!-- <v-layout row>
            <v-btn flat color="orange" @click="show = !show;">{{
              getString("Cambia immagine (MAX. 2MB)")
            }}</v-btn>
             <v-btn flat color="orange" @click="showLogoUpload = !showLogoUpload;">{{
              getString("Cambia logo (MAX. 1MB)")
            }}</v-btn>
            </v-layout> -->
          </v-layout>
          <!-- <div class="center">
            <v-btn
              flat
              color="orange"
              :class="{ 'save-alert': saveAlert }"
              @click="setShop"
              >{{ getString("Salva") }}</v-btn
            >
          </div> -->
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ shop.name }}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout class="formDesc" row wrap>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Indirizzo") }}</label>
                <v-text-field
                  v-model="shop.address"
                  :rules="notEmpty"
                  solo
                  class="form-padding"
                  :label="getString('Inserisci il tuo indirizzo')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("La provincia") }}</label>
                <v-text-field
                  v-model="shop.prov"
                  :rules="notEmpty"
                  solo
                  class="form-padding"
                  :label="getString('Prov.')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Città") }}</label>
                <v-text-field
                  v-model="shop.city"
                  :rules="notEmpty"
                  class="form-padding"
                  solo
                  :label="getString('Città')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Cap") }}</label>
                <v-text-field
                  v-model="shop.cap"
                  :rules="notEmpty"
                  class="form-padding"
                  solo
                  :label="getString('CAP')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg4>
                <label>{{ getString("Il tuo telefono") }}</label>
                <v-text-field
                  v-model="shop.phone"
                  class="form-padding"
                  solo
                  :label="getString('Inserisci il tuo telefono')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg4>
                <label>{{ getString("Il tuo secondo numero") }}</label>
                <v-text-field
                  v-model="shop.phone2"
                  class="form-padding"
                  solo
                  :label="getString('Inserisci il tuo secondo numero')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg4>
                <label>{{ getString("Whatsapp") }}</label>
                <v-text-field
                  v-model="shop.whatsapp"
                  class="form-padding"
                  solo
                  :label="getString('Inserisci il numero che usi per whatsapp')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Pagina Facebook") }}</label>
                <v-text-field
                  v-model="shop.facebookLink"
                  :rules="urlRule"
                  class="form-padding"
                  solo
                  :label="getString('Link: https://facebook.com/nomepagina')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Profilo instagram") }}</label>
                <v-text-field
                  v-model="shop.instagramLink"
                  :rules="urlRule"
                  class="form-padding"
                  solo
                  :label="getString('Link: https://www.instagram.com/@nome')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6>
                <label>{{ getString("Sito web") }}</label>
                <v-text-field
                  v-model="shop.webSiteLink"
                  :rules="urlRule"
                  class="form-padding"
                  solo
                  :label="getString('Link: https://www.nomesito.estensione')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <label>{{ getString("Descrizione") }}</label>
                <editor
                style="background-color: red;"
                  api-key="vn43j4ndioj2ysq09jicr7yfha8fvqcp8kye03mrgsixspv4"
                  v-bind:label="getString('Descrizione del negozio')"
                  v-model="shop.description"
                  :init="{
                    
                    selector: 'textarea',
                    language_url: '../../static/languages/tinymce/it.js',
                    menubar: false,
                    min_height: 300,
                    branding: false,
                  }"
                ></editor>
              </v-flex>
              <v-flex xs12 class="center">
                <v-btn
                  flat
                  color="orange"
                  :class="{ 'save-alert': saveAlert }"
                  @click="setShop"
                  >{{ getString("Salva") }}</v-btn
                >
              </v-flex>
              <v-flex style="margin-top: 20px" xs12 sm12 md6 lg6>
                <label>{{ getString("Altro") }}</label>
                <h3 style="margin-left: 10px" class="q-orange">
                  {{ getString("Codice identificativo: ") }}{{ shop.idCode }}
                </h3>
                <h3
                  v-if="!$store.getters.hasDlc('V10')"
                  style="margin-left: 10px"
                  class="q-orange"
                >
                  {{ getString("Scadenza abbonamento: ") }}{{ expiredDate }}
                </h3>
                <h3
                  v-if="$store.getters.hasDlc('V10')"
                  style="margin-left: 10px"
                  class="q-orange"
                >
                  {{ getString("Scadenza abbonamento: ILLIMITATO") }}
                </h3>
                <span
                  v-if="!$store.getters.hasDlc('V10')"
                  style="margin-left: 10px"
                >
                  {{
                    getString(
                      "L'abbondamento scadrà dopo il seguente numero di giorni: "
                    )
                  }}
                  <b>{{ shop.daysToExpire }}</b>
                </span>
                <!-- <v-btn class="q-orange-bk q-text-whitesmoke" @click="qrCode">{{
                  getString("Login QrCode")
                }}</v-btn> -->
              </v-flex>
            </v-layout>
          </v-card-text>
          <!--
            <v-card-actions>
              <v-btn
                flat
                color="orange"
                :class="{ 'save-alert': saveAlert }"
                @click="setShop"
                >{{ getString("Salva") }}</v-btn
              >
            </v-card-actions>
          -->
          <v-card-text v-show="isUploading">
            <v-progress-linear :value="fileUploadProgress"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-flex>
   
      <my-upload
        ref="fileToUpload"
        noCircle
        @crop-success="cropSuccess"
        v-model="show"
        :width="1050"
        :height="645"
        @src-file-set="sourceSet"
        :withCredentials="true"
        langType="it"
      ></my-upload>
      <my-upload
        ref="logoToUpload"
        noSquare
        @crop-success="cropLogoSuccess"
        v-model="showLogoUpload"
        :width="500"
        :height="500"
        @src-file-set="sourceLogoSet"
        :withCredentials="true"
        langType="it"
      ></my-upload>
    </v-layout>
    <v-dialog v-model="qrcodeDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          getString("QrCode App")
        }}</v-card-title>
        <v-card-text>
          <p>
            {{
              getString(
                "Apri l'app QuickBe Cal e riprendi questo qrcode per effettuare il login"
              )
            }}
          </p>
          <div class="text-center">
            <vue-qr :size="400" :text="token"></vue-qr>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="q-orange" flat @click="qrcodeDialog = false">{{
            getString("Chiudi")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--
      <modal v-show="confirmDelete" @click="confirmDelete = false;">
        <v-card-title class="no-padding" slot="header">
          <v-toolbar color="red darken-2" style="text-align:center">
            <span class="headline q-text-whitesmoke text-center">{{
              getString("Conferma cancellazione")
            }}</span>
          </v-toolbar>
        </v-card-title>
        <v-card-text slot="body">
          <v-layout wrap>
            <p>
              {{
                getString(
                  "La cancellazione del servizio è irreversibile Confermi?"
                )
              }}
            </p>
          </v-layout>
          <v-progress-linear
            indeterminate
            v-show="isLoading"
            :active="isLoading"
            :height="2"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions slot="footer">
          <v-btn
            class="q-orange"
            flat
            :disabled="isLoading"
            @click.native="confirmDelete = false;"
            >{{ getString("No") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="q-orange-bk q-text-whitesmoke"
            :disabled="isLoading"
            @click.native="deleteReservation"
            >{{ getString("Conferma") }}</v-btn
          >
        </v-card-actions>
      </modal>
    -->
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import ModalQ from "../../utils/ModalQ";
import DialogImages from "../../utils/DialogImages";
import draggable from "vuedraggable";
import myUpload from "vue-image-crop-upload";
import ImageCompressor from "image-compressor.js";
import Moment from "moment";
import VueQr from "vue-qr";

var ut = new Utils();
export default {
  name: "ShopDesc",
  props: ["shopID", "tab"],
  components: {
    draggable,
    ProgressQ,
    DialogImages,
    ModalQ,
    VueQr,
    "my-upload": myUpload,
    editor: Editor,
  },
  mounted: function () {
    this.getShop();
    this.getPrices();
    this.getPricesImages();
  },
  computed: {
    token: function () {
      return this.$store.getters.token;
    },
    tenMinRule: function () {
      return [
        (v) => Number.parseInt(v) >= 10 || this.getString("Minimo 10 minuti"),
      ];
    },
    expiredDate: function () {
      return new Moment(this.shop.expired).locale("it").format("DD MMMM YYYY");
    },
    maxSort: function () {
      let max = 0;
      this.prices.forEach((element) => {
        if (element.sort > max) max = element.sort;
      });
      return max;
    },
    pwdConfirmRule: function () {
      return [
        (v) => v === this.pwd || this.getString("Le password non coincidono"),
      ];
    },
    minLenghtRule: function () {
      return [
        (v) =>
          v == undefined ||
          v == "" ||
          ut.MinLengthValidate(v, 8) ||
          this.getString("Password troppo corta, almeno 8 caratteri"),
      ];
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    urlRule: function () {
      return [
        (v) =>
          v == "" ||
          v == null ||
          ut.validateUrl(v) ||
          this.getString("Url non valido"),
      ];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateNumber(v) || this.getString("Numero non valido"),
      ];
    },
    saveAlert: function () {
      if (this.tab !== 0) return false;
      let val =
        this.image !== null ||
        this.logo !== null ||
        this.shop.address !== this.oldShop.address ||
        this.shop.cap !== this.oldShop.cap ||
        this.shop.city !== this.oldShop.city ||
        this.shop.prov !== this.oldShop.prov ||
        this.shop.phone !== this.oldShop.phone ||
        this.shop.phone2 !== this.oldShop.phone2 ||
        this.shop.whatsapp !== this.oldShop.whatsapp ||
        this.shop.facebookLink !== this.oldShop.facebookLink ||
        this.shop.instagramLink !== this.oldShop.instagramLink ||
        this.shop.webSiteLink !== this.oldShop.webSiteLink ||
        this.shop.description !== this.oldShop.description ||
        this.shop.serviceNote !== this.oldShop.serviceNote;

      if (val && !this.$store.state.modifying) {
        this.$store.commit("isModifying");
      }
      if (!val && this.$store.state.modifying) {
        this.$store.commit("notIsModifying");
      }
      return val;
    },
    defaultAvatar: function () {
      if (
        this.shop.imageLink === null ||
        this.shop.imageLink === "/images/shopdefault.png" ||
        this.shop.imageLink === "images/shopdefault.png"
      ) {
        return "../../../static/img/shopdefault.png";
      } else
        return (
          this.shop.imageLink + "?t=" + new Date().getSeconds()
        );
    },
    shopLoad: function () {
      return this.shop.name === null;
    },
    sortOptions: function () {
      return {
        handle: ".handle",
      };
    },
    sortOrder: function () {
      let temp = [];
      let i = 0;
      this.prices.forEach((e) => {
        temp[i++] = e.sort;
      });
      return temp;
    },
  },
  data: () => {
    return {
      h: null,
      show: false,
      showLogoUpload: false,
      hidden: false,
      editTime: false,
      dialogChangeIcon: false,
      currentElementiIconPicked: { image: ""},
      qrcodeDialog: false,
      image: null,
      logo: null,
      imageName: "",
      logoName: "",
      fileUploadProgress: 0,
      isLoading: false,
      isUploading: false,
      priceImage: null,
      priceName: null,
      priceTime: null,
      pricePrice: null,
      priceImages: [],
      shop: {
        name: null,
        address: null,
        prov: null,
        city: null,
        cap: null,
        phone: null,
        phone2: null,
        whatsapp: null,
        facebookLink: null,
        instagramLink: null,
        webSiteLink: null,
        description: null,
        expired: null,
        daysToExpire: null,
        serviceNote: null,
        logoLink: null,
        imageLink: null,
        state: 2,
      },
      oldShop: {
        name: "",
        address: "",
        prov: "",
        cap: "",
        city: "",
        phone: "",
        phone2: "",
        whatsapp: "",
        facebookLink: "",
        instagramLink: "",
        webSiteLink: "",
        description: "",
        serviceNote: "",
      },
      prices: [],
      categories: []
    };
  },
  watch: {
    shopID: function () {
      if (this.shopID > 0) {
        this.getShop();
        this.getPrices();
      }
    },
  },
  methods: {
    // changeIcon: function (element) {
    //   this.currentElementiIconPicked = element;
    //   this.dialogChangeIcon = true;
    // },
    // loadImage: function (item) {
    //   this.currentElementiIconPicked.image = item.path;
    // },
    onImageUploaded: function (imageItem) {
      this.priceImages = [...this.priceImages, imageItem];
    },
    getPricesImages: function () {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/shops/prices/images?shopId=" + self.shopID, {
          headers: {
            Authorization: "Bearer " + self.$store.getters.token,
          },
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.priceImages = response.data.data.images;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    addPrice: function () {
      let data = {
        priceName: this.priceName.trim(),
        priceTime: this.priceTime.trim(),
        pricePrice: this.pricePrice.trim(),
        priceImage: this.currentElementiIconPicked.image
      };
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices/new",
          data,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data.text);
          self.prices = response.data.data.prices;
          self.priceName = null;
          self.priceTime = null;
          self.pricePrice = null;
          self.currentElementiIconPicked.image = ""
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    removePrice: function (item, ele) {
      let self = this;
      ele.currentTarget.disabled = true;
      if (self.shopID > 0) {
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/prices/" +
              item.idPrice,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit(
              "siteAlertSuccess",
              self.getString("Servizio eliminato.")
            );
            self.prices = response.data.data.prices;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
            ele.currentTarget.disabled = false;
          });
      }
    },
    resetPrice: function () {
      this.editTime = false;
      this.getPrices();
    },
    updatePrice: function () {
      let self = this;
      this.isLoading = true;
      if (self.shopID > 0) {
        ajax.axios
          .put(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices/",
            self.prices,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit(
              "siteAlertSuccess",
              self.getString("Servizi aggiornati.")
            );
            self.editTime = false;
            self.isLoading = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
            self.isLoading = false;
          });
      }
    },
    updateSort: function (e) {
      this.isLoading = true;
      let old = e.oldIndex;
      let newI = e.newIndex;
      if (old < newI) {
        for (let i = old + 1; i <= newI; i++) {
          if (old <= this.prices.length) this.prices[i].sort = i;
        }
      }
      if (old > newI) {
        for (let i = newI - 1; i <= old; i++) {
          if (i >= 0) this.prices[i].sort = i;
        }
      }
      let data = this.prices;
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices",
          data,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.$emit("siteAlertSuccess", self.getString("Aggiornato"));
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    qrCode: function () {
      this.qrcodeDialog = true;
    },
    test: function () {
      this.$emit("siteAlert", "Hello!");
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    getPrices: function () {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.prices = response.data.data.prices;
            self.categories = response.data.data.categories;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    getShop: function () {
      let self = this;
      this.shop.name = null;
      if (self.shopID > 0) {
        ajax.axios
          .get(ajax.baseUrl() + "/admin/shops/shop/" + self.shopID, {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          })
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.shop = response.data.data;
            self.oldShop.address = self.shop.address;
            self.oldShop.prov = self.shop.prov;
            self.oldShop.cap = self.shop.cap;
            self.oldShop.city = self.shop.city;
            self.oldShop.phone = self.shop.phone;
            self.oldShop.phone2 = self.shop.phone2;
            self.oldShop.whatsapp = self.shop.whatsapp;
            self.oldShop.facebookLink = self.shop.facebookLink;
            self.oldShop.instagramLink = self.shop.instagramLink;
            self.oldShop.webSiteLink = self.shop.webSiteLink;
            self.oldShop.description = self.shop.description;
            self.oldShop.serviceNote = self.shop.serviceNote;
            self.shop.logoLink = self.shop.logoLink;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
            setTimeout(function () {
              location.href = "/admin/dashboard";
            }, 3000);
          });
      }
    },
    cropSuccess(imgDataUrl, field) {
      this.$refs.avatar.src = imgDataUrl;
      this.image = ut.data2blob(
        imgDataUrl,
        ut.getFileExtension(this.imageName)
      );
      this.setShop();
    },
    cropLogoSuccess(imgDataUrl, field) {
      this.$refs.logo.src = imgDataUrl;
      this.logo = ut.data2blob(imgDataUrl, ut.getFileExtension(this.logoName));
      this.setShop();
    },
    sourceSet: function (name, type, size) {
      this.imageName = this.$refs.fileToUpload.$refs.fileinput.files[0].name;
    },
    sourceLogoSet: function (name, type, size) {
      this.logoName = this.$refs.logoToUpload.$refs.fileinput.files[0].name;
    },
    setShop: async function () {
      if (this.saveAlert) {
        this.isUploading = true;
        let self = this;
        var data = new FormData();
        if (this.shop.address !== null)
          data.append("address", this.shop.address);
        if (this.shop.city !== null) data.append("city", this.shop.city);
        if (this.shop.prov !== null) data.append("prov", this.shop.prov);
        if (this.shop.cap !== null) data.append("cap", this.shop.cap);
        if (this.shop.city !== null) data.append("city", this.shop.city);
        if (this.shop.phone !== null) data.append("phone", this.shop.phone);
        if (this.shop.phone2 !== null) data.append("phone2", this.shop.phone2);
        if (this.shop.serviceNote !== null)
          data.append("serviceNote", this.shop.serviceNote);
        if (this.shop.whatsapp !== null)
          data.append("whatsapp", this.shop.whatsapp);
        if (this.shop.facebookLink !== null)
          data.append("fbLink", this.shop.facebookLink);
        if (this.shop.instagramLink !== null)
          data.append("inLink", this.shop.instagramLink);
        if (this.shop.webSiteLink !== null)
          data.append("wsLink", this.shop.webSiteLink);
        if (this.shop.description !== null)
          data.append("desc", this.shop.description);
        if (this.image !== null) {
          const imageCompressor = new ImageCompressor();
          const compressed = await imageCompressor.compress(this.image, {
            quality: 0.7,
          });
          data.append("files", compressed, self.imageName);
        }
        if (this.logo !== null) {
          const imageCompressor = new ImageCompressor();
          const compressed = await imageCompressor.compress(this.logo, {
            quality: 0.7,
          });
          data.append("logo", compressed, self.logoName);
        }
        ajax.axios
          .put(ajax.baseUrl() + "/admin/shops/shop/" + self.shopID, data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + self.$store.getters.token,
            },
            onUploadProgress: function (progressEvent) {
              let p = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
              self.fileUploadProgress = p;
            }.bind(this),
            withCredentials: true,
          })
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.isUploading = false;
            self.fileUploadProgress = 0;
            self.$emit("siteAlertSuccess", response.data.data.text);
            self.image = null;
            self.logo = null;
            self.shop = response.data.data.shop;
            self.oldShop.address = self.shop.address;
            self.oldShop.prov = self.shop.prov;
            self.oldShop.cap = self.shop.cap;
            self.oldShop.phone = self.shop.phone;
            self.oldShop.phone2 = self.shop.phone2;
            self.oldShop.whatsapp = self.shop.whatsapp;
            self.oldShop.facebookLink = self.shop.facebookLink;
            self.oldShop.instagramLink = self.shop.instagramLink;
            self.oldShop.webSiteLink = self.shop.webSiteLink;
            self.oldShop.description = self.shop.description;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.fileUploadProgress = 0;
            self.isUploading = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      } else {
        this.$emit("siteAlert", this.getString("Nessuna modifica richiesta"));
      }
    },
  },
};
</script>

<style scoped>
.formDesc {
  align-items: center;
  margin-bottom: 20px;
}
.formDesc label,
.formDesc v-text-field {
  margin: 10px;
}

.icon-button {
  border: 2px solid orange;
  padding: 5px;
  border-radius: 5px;
}
.pricesElements {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  text-align: center;
}

.pricesElements span {
  flex-grow: 1;
  padding: 10px;
}

.pricesElements .desc {
  flex-grow: 3;
  width: 80%;
  text-align: left;
}

.avatar-img {
  position: relative;
  width: 1065px;
  /* width: 100%; */
  height: 430px;
  max-height: 430px;
  object-fit: cover;
  transition: max-height 0.3s ease-in-out;
}
@media (max-width: 1200px) {
  .avatar-img {
    width: 100%;
    max-height: 300px;
  }
}

/* .avatar-img:hover {
  max-height: 1000px;
} */

.save-alert {
  animation-name: saveAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

.img-badge {
  width: 70px;
  position: absolute;
  top: 5px;
  right: 5px;
}
.wrapper-logo {
  position: absolute;
  bottom: 0;
  text-align: center;
  background: white;
  border-radius: 50%;
  overflow: hidden;
  border: solid lightgrey 2px;
  height: 125px;
  width: 125px;
  cursor: pointer;
  
}
.img-logo {
  width: 100%;
}

.form-padding {
  padding: 5px !important;
}

@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: orange;
  }

  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopDesc.vue